/*
 * goat-lp-merch-product.js — progressive enhancement for
 * sections/goat-lp-merch-product.liquid.
 *
 * The form posts natively to /cart/add (return_to=/checkout); this script only
 * syncs the selected variant -> hidden id / price / availability / image / URL,
 * drives the quantity stepper and the thumbnail navigation. No Dawn globals.
 */
(function () {
  'use strict';

  if (window.GoatLPMerch) return;
  window.GoatLPMerch = true;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || root.dataset.merchReady) return;
    root.dataset.merchReady = 'true';

    var variants = [];
    var dataEl = root.querySelector('[data-merch-variants]');
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        variants = [];
      }
    }

    var form = root.querySelector('[data-merch-form]');
    var idInput = root.querySelector('[data-merch-variant-id]');
    var priceEl = root.querySelector('[data-merch-price]');
    var saleLabel = root.querySelector('[data-merch-sale-label]');
    var compareEl = root.querySelector('[data-merch-compare]');
    var compareValue = root.querySelector('[data-merch-compare-value]');
    var soldOutEl = root.querySelector('[data-merch-sold-out]');
    var submit = root.querySelector('[data-merch-submit]');
    var submitLabel = root.querySelector('[data-merch-submit-label]');
    var stage = root.querySelector('[data-merch-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-merch-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-merch-slide]'));
    var fieldsets = Array.prototype.slice
      .call(root.querySelectorAll('[data-merch-option]'))
      .sort(function (a, b) {
        return Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex);
      });

    var labels = {
      buy: root.dataset.labelBuy || '',
      soldOut: root.dataset.labelSoldOut || '',
      unavailable: root.dataset.labelUnavailable || ''
    };

    /* ---------------------------------------------------------------- gallery */

    function setCurrentThumb(mediaId) {
      thumbs.forEach(function (t) {
        if (t.dataset.mediaId === String(mediaId)) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });
    }

    function scrollToSlide(mediaId) {
      if (!stage) return;
      var slide = null;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === String(mediaId)) {
          slide = slides[i];
          break;
        }
      }
      if (!slide) return;
      stage.scrollTo({
        left: slide.offsetLeft - stage.offsetLeft,
        behavior: reducedMotion() ? 'auto' : 'smooth'
      });
      setCurrentThumb(mediaId);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        scrollToSlide(t.dataset.mediaId);
      });
    });

    if (stage && thumbs.length) {
      var ticking = false;
      stage.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            if (!stage.clientWidth) return;
            var index = Math.round(stage.scrollLeft / stage.clientWidth);
            var slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
            if (slide) setCurrentThumb(slide.dataset.mediaId);
          });
        },
        { passive: true }
      );
    }

    /* --------------------------------------------------------------- variants */

    function selected() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      var values = selected();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function markUnavailable() {
      var current = selected();
      fieldsets.forEach(function (fs, optIndex) {
        var inputs = fs.querySelectorAll('input[type="radio"]');
        Array.prototype.forEach.call(inputs, function (input) {
          var ok = variants.some(function (v) {
            if (!v.available || v.options[optIndex] !== input.value) return false;
            for (var k = 0; k < current.length; k++) {
              if (k === optIndex) continue;
              if (v.options[k] !== current[k]) return false;
            }
            return true;
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function apply(variant) {
      if (idInput) idInput.value = variant ? variant.id : '';

      if (variant) {
        if (priceEl) priceEl.textContent = variant.price;
        var onSale = !!variant.compare_at_price;
        if (compareEl) compareEl.hidden = !onSale;
        if (compareValue) compareValue.textContent = onSale ? variant.compare_at_price : '';
        if (saleLabel) saleLabel.hidden = !onSale;
      } else {
        if (compareEl) compareEl.hidden = true;
        if (saleLabel) saleLabel.hidden = true;
      }

      if (soldOutEl) soldOutEl.hidden = !variant || variant.available;

      if (submit) {
        var buyable = !!(variant && variant.available);
        submit.disabled = !buyable;
        if (submitLabel) {
          submitLabel.textContent = !variant ? labels.unavailable : variant.available ? labels.buy : labels.soldOut;
        }
      }

      if (variant && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {
          /* ignore */
        }
      }

      if (variant && variant.featured_media_id) scrollToSlide(variant.featured_media_id);
    }

    if (fieldsets.length && variants.length) {
      fieldsets.forEach(function (fs) {
        fs.addEventListener('change', function () {
          apply(findVariant());
          markUnavailable();
        });
      });
      markUnavailable();
    }

    /* ---------------------------------------------------------------- stepper */

    var qtyInput = root.querySelector('[data-merch-qty-input]');
    if (qtyInput) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-merch-qty]'), function (btn) {
        btn.addEventListener('click', function () {
          var step = Number(btn.dataset.merchQty) || 0;
          var current = parseInt(qtyInput.value, 10);
          if (isNaN(current)) current = 1;
          qtyInput.value = Math.max(1, current + step);
        });
      });
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) qtyInput.value = 1;
      });
    }

    /* ----------------------------------------------------------------- submit */

    if (form && submit) {
      form.addEventListener('submit', function () {
        submit.classList.add('is-loading');
        submit.setAttribute('aria-busy', 'true');
      });
    }

    /* Restore the button when the page comes back from the bfcache (Back). */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && submit) {
        submit.classList.remove('is-loading');
        submit.removeAttribute('aria-busy');
      }
    });
  }

  function initAll(scope) {
    var ctx = scope || document;
    if (ctx.matches && ctx.matches('[data-goat-merch-product]')) init(ctx);
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-goat-merch-product]'), init);
  }

  if (document.readyState !== 'loading') {
    initAll(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
